<file-storage [componentId]="'file-home'" [isPortable]="false"></file-storage>